import { Weblab } from '@amzn/katal-weblab';
import { WeblabType } from '@amzn/katal-weblab-sellercentral';


// ALL Eligible treatments from weblab
export enum WEBLAB_TREATMENTS {
    Control = 'C',
    Treatment1 = 'T1',
    Treatment2 = 'T2'
}

export const SWITCH_DELPHI_ABC_WEBLAB: Weblab = {
    id: 'ANSFOOTER_DELPHI_ABC_SWITCH_897115',
    defaultTreatment: WEBLAB_TREATMENTS.Control,
    weblabType: WeblabType.Customer
};
